export default {
  methods: {
    // 删除SPU
    handleRetouchStartStart() {
      this.$confirm((<div class="jsx-content">
        确定开始修片？
      </div>), '开始修片')
      .then(_=>{
        this.$message('确认按钮')
      })
      .catch(_=>{
        this.$message('取消按钮')
      })
    }
  }
}